import { unknownEmailsLimitFromAbility } from '@/helpers/unknownEmailsLimit.js'

/**
 * Спільний доступ компонентів до ліміту незареєстрованих контактів в одному запрошенні.
 * Правило створюється в store/actions/authActions.js (setCredentials):
 * can('invite', 'UnknownEmailsLimit', { limit }).
 */
export default {
  computed: {
    /**
     * Ліміт з CASL-правила (ціле >= 0); null = фіча вимкнена.
     * @returns {number|null}
     */
    $_unknownEmailsLimit() {
      // $can — реактивна залежність від оновлення $ability (relevantRuleFor сам по собі не відстежується)
      return this.$can('invite', 'UnknownEmailsLimit') ? unknownEmailsLimitFromAbility(this.$ability) : null
    },
    /**
     * Ліміт активний, коли є CASL-правило (0 теж активний ліміт)
     */
    $_unknownEmailsLimitActive() {
      return this.$_unknownEmailsLimit !== null
    },
    /**
     * Підказка «Можна додати не більше N незареєстрованих контактів»
     */
    $_unknownEmailsLimitHint() {
      return this.$t('Tenders.UnknownEmailsLimitHint', { limit: this.$_unknownEmailsLimit })
    },
  }
}
